import { Pipe, PipeTransform } from '@angular/core';

export function getLayerKey(layer: __esri.FeatureLayer | __esri.Sublayer) {
    if ((<__esri.Layer>layer).type === 'feature') {
        return layer.id.toString();
    } else {
        const sublayer = <__esri.Sublayer>layer;
        return `${sublayer.layer.id}-${sublayer.id}`;
    }
}

@Pipe({ name: 'mcLayerKey' })
export class LayerKeyPipe implements PipeTransform {
    transform(layer: __esri.FeatureLayer | __esri.Sublayer): string {
        return getLayerKey(layer);
    }
}
